<template>
  <span>
    <div class="p-fluid formgrid grid">
      <div v-show="exibirListaEntidades" class="field col-6 md:col-6">
        <label for="entidade">Entidade</label>
        <MultiSelect
          id="entidade"
          v-model="v$.entidadesSelecionadas.$model"
          :class="{
            'p-invalid': submitted && v$.entidadesSelecionadas.$invalid,
          }"
          optionLabel="nome"
          :options="entidades"
          :filter="true"
          filterPlaceholder="Procure pelo nome da entidade"
          :emptyFilterMessage="'Nenhuma entidade encontrada'"
          placeholder="Selecione uma entidade"
          display="chip"
          @input="adicionarEntidade">
        </MultiSelect>
        <div
          v-if="submitted && v$.entidadesSelecionadas.required.$invalid"
          class="p-error">
          O campo entidade é obrigatório.
        </div>
      </div>
      <div v-show="exibirListaConsignataria" class="field col-6 md:col-6">
        <label for="consignataria">Consignatária</label>
        <MultiSelect
          id="consignataria"
          v-model="v$.consignatariasSelecionadas.$model"
          dataKey="id"
          :disabled="habilitarCampoConsignataria"
          :class="{
            'p-invalid': submitted && v$.consignatariasSelecionadas.$invalid,
          }"
          optionLabel="cnpjRazaoSocial"
          :options="concatenarCnpjRazaoSocial"
          :filter="true"
          filterPlaceholder="Procure pelo nome da consignataria"
          :emptyFilterMessage="'Nenhuma consignataria encontrada'"
          placeholder="Selecione uma consignataria"
          display="chip"
          @input="adicionarConsignataria">
        </MultiSelect>
        <div
          v-if="submitted && v$.consignatariasSelecionadas.required.$invalid"
          class="p-error">
          O campo consignataria é obrigatório.
        </div>
      </div>
      <div class="field col-6 md:col-6">
        <label for="dataInicio">Data Inicial</label>
        <Calendar
          id="dataInicio"
          v-model="v$.dataInicio.$model"
          class="w-full"
          :class="{
            'p-invalid': submitted && v$.dataInicio.$invalid,
          }"
          dateFormat="dd/mm/yy"
          @input="adicionardataInicio" />
        <div
          v-if="submitted && v$.dataInicio.required.$invalid"
          class="p-error">
          O campo data cadastro início é obrigatório.
        </div>
      </div>
      <div class="field col-6 md:col-6">
        <label for="dataFim">Data Final</label>
        <Calendar
          id="dataFim"
          v-model="v$.dataFim.$model"
          :class="{
            'p-invalid': submitted && v$.dataFim.$invalid,
          }"
          dateFormat="dd/mm/yy"
          @input="adicionardataFim" />
        <div v-if="submitted && v$.dataFim.required.$invalid" class="p-error">
          O campo data cadastro fim é obrigatório.
        </div>
      </div>
    </div>

    <div class="p-fluid formgrid grid">
      <div class="flex flex-column col-6">
        <label for="operacao1">Tipo de Operação:</label>
        <div
          class="flex flex-row"
          style="gap: 10px; margin-top: 10px; justify-content: center">
          <RadioButton
            v-model="operacaoMarcada"
            inputId="cadastroButton"
            value="cadastro"
            name="operacao"
            @input="adicionarEscolhaOperacao" />
          <label for="cadastroButton">Cadastro</label>
          <RadioButton
            id="operacao2"
            v-model="operacaoMarcada"
            inputId="atualizacaoButton"
            value="atualizacao"
            name="operacao"
            @input="adicionarEscolhaOperacao" />
          <label for="atualizacaoButton">Atualização</label>
          <RadioButton
            id="operacao3"
            v-model="operacaoMarcada"
            inputId="ambosButton"
            value="ambos"
            name="operacao"
            @input="adicionarEscolhaOperacao" />
          <label for="ambosButton">Âmbos</label>
        </div>
      </div>
      <div class="field col-6 md:col-6">
        <label for="status">Situação</label>
        <MultiSelect
          id="status"
          v-model="v$.statusSelecionados.$model"
          data-key="id"
          :class="{
            'p-invalid': submitted && v$.statusSelecionados.$invalid,
          }"
          :options="listaStatus"
          optionLabel="descricao"
          filterPlaceholder="Procure pelo nome da situação"
          :emptyFilterMessage="'Nenhuma situação encontrada'"
          placeholder="Selecione uma situação"
          display="chip"
          :filter="true"
          @input="adicionarStatus">
        </MultiSelect>
        <div
          v-if="submitted && v$.statusSelecionados.required.$invalid"
          class="p-error">
          O campo situação é obrigatório.
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import UseVuelidate from '@vuelidate/core'
import { required, requiredIf } from '@vuelidate/validators'
import ConsignatariaService from '@/service/ConsignatariaService.js'
import { consignatariaStore } from '@/stores/consignataria'
import EntidadeService from '@/service/EntidadeService.js'
import StatusReservaDeCartaoService from '@/service/StatusReservaDeCartaoService.js'
import ServidorService from '@/service/ServidorService.js'

export default {
  name: 'LayoutFiltro02',

  props: {
    submitted: {
      type: Boolean,
      default: false,
    },
    modulo: {
      type: String,
      required: true,
    },
  },

  setup() {
    const store = consignatariaStore()
    return { v$: UseVuelidate(), store }
  },

  data() {
    return {
      operacaoMarcada: 'cadastro',
      operacoes: [],
      entidadesSelecionadas: [],
      entidades: [],
      entidadesIdSelecionados: [],
      consignatariasSelecionadas: [],
      consignatarias: [],
      listaStatus: [],
      statusSelecionados: [],
      statusIdSelecionados: [],
      consignatariasIdSelecionados: [],
      dataInicio: '',
      dataFim: '',
      cpf: null,
      exibirListaEntidades: false,
      exibirListaConsignataria: false,
      parametros: new Map(),
    }
  },

  computed: {
    habilitarCampoConsignataria() {
      return this.store.consignatariaSelecionada !== null
    },

    concatenarCnpjRazaoSocial() {
      return this.consignatarias.map((consignataria) => ({
        ...consignataria,
        cnpjRazaoSocial: consignataria.cnpj + ' | ' + consignataria.razaoSocial,
      }))
    },
  },

  validations() {
    return {
      dataInicio: { required },
      dataFim: { required },
      consignatariasSelecionadas: {
        required: requiredIf(
          this.$auth.hasRoleGestao() || this.$auth.hasRoleGestaoEntidade()
            ? true
            : false,
        ),
      },
      statusSelecionados: { required },
      entidadesSelecionadas: { required },
    }
  },

  created() {
    this.consignatariaService = new ConsignatariaService(this.$http)
    this.entidadeService = new EntidadeService(this.$http)
    this.statusReservaDeCartaoService = new StatusReservaDeCartaoService(
      this.$http,
    )
    this.servidorService = new ServidorService(this.$http)
  },

  mounted() {
    this.carregarListaStatus()
    this.carregarEntidade()
    this.carregarConsignataria()
    this.carregarCpf()
    this.adicionarEscolhaOperacao()
  },

  methods: {
    validate() {
      this.v$.dataInicio.$touch()
      this.v$.dataFim.$touch()
      this.v$.consignatariasSelecionadas.$touch()
      this.v$.statusSelecionados.$touch()
      this.v$.entidadesSelecionadas.$touch()

      return !(
        this.v$.dataInicio.$invalid ||
        this.v$.dataFim.$invalid ||
        this.v$.consignatariasSelecionadas.$invalid ||
        this.v$.statusSelecionados.$invalid ||
        this.v$.entidadesSelecionadas.$invalid
      )
    },

    carregarEntidade() {
      this.carregarListaEntidades()
      this.exibirListaEntidades = true
    },

    carregarConsignataria() {
      this.carregarListaConsignatarias()
      this.exibirListaConsignataria = true
    },

    carregarListaStatus() {
      this.statusReservaDeCartaoService
        .getStatusReservaDeCartao()
        .then((res) => {
          this.listaStatus = res
        })
    },

    carregarCpf() {
      this.servidorService.getDadosServidor().then((res) => {
        if (this.modulo === 'servidor') {
          this.cpf = res.cpf
          this.adicionarCpf()
        }
      })
    },

    adicionardataInicio() {
      this.parametros.set(
        'dataInicio',
        this.converterDataParaDateStylePadrao(
          this.dataInicio.toLocaleDateString('pt-BR'),
        ),
      )
      this.$emit('parametros', this.parametros)
    },

    adicionardataFim() {
      this.parametros.set(
        'dataFim',
        this.converterDataParaDateStylePadrao(
          this.dataFim.toLocaleDateString('pt-BR'),
        ),
      )
      this.$emit('parametros', this.parametros)
    },

    adicionarEscolhaOperacao() {
      if (this.operacaoMarcada == 'cadastro') {
        this.operacoes = [0]
        this.parametros.set('operacao', this.operacoes)
      }
      if (this.operacaoMarcada == 'atualizacao') {
        this.operacoes = [1]
        this.parametros.set('operacao', this.operacoes)
      }
      if (this.operacaoMarcada == 'ambos') {
        this.operacoes = [0, 1]
        this.parametros.set('operacao', this.operacoes)
      }
      this.$emit('parametros', this.parametros)
    },

    converterDataParaDateStylePadrao(data) {
      const [day, month, year] = data.split('/')
      return `${year}-${month}-${day}`
    },

    adicionarStatus() {
      this.adicionarListaIds('status')
      this.parametros.set('statusId', this.statusIdSelecionados)
      this.$emit('parametros', this.parametros)
      this.statusIdSelecionados = []
    },

    adicionarEntidade() {
      this.adicionarListaIds('entidade')
      this.parametros.set('entidadeId', this.entidadesIdSelecionados)
      this.$emit('parametros', this.parametros)
      this.entidadesIdSelecionados = []
    },

    adicionarConsignataria() {
      this.adicionarListaIds('consignataria')
      this.parametros.set('consignatariaId', this.consignatariasIdSelecionados)
      this.$emit('parametros', this.parametros)
      this.consignatariasIdSelecionados = []
    },

    adicionarCpf() {
      this.parametros.set('cpf', this.cpf)
      this.$emit('parametros', this.parametros)
    },

    adicionarListaIds(tipo) {
      if (tipo == 'status') {
        this.statusSelecionados.forEach((valor) =>
          this.statusIdSelecionados.push(valor.id.toString()),
        )
      } else if (tipo == 'entidade') {
        this.entidadesSelecionadas.forEach((valor) =>
          this.entidadesIdSelecionados.push(valor.id.toString()),
        )
      } else if (tipo == 'consignataria') {
        this.consignatariasSelecionadas.forEach((valor) =>
          this.consignatariasIdSelecionados.push(valor.id.toString()),
        )
      }
    },

    limpar() {
      if (this.modulo !== 'servidor') {
        this.cpf = null
      }
      this.entidadesSelecionadas = []
      this.entidadesIdSelecionados = []
      this.consignatariasSelecionadas = []
      this.consignatariasIdSelecionados = []
      this.statusSelecionados = []
      this.statusIdSelecionados = []
      this.dataInicio = ''
      this.dataFim = ''
    },
  },
}
</script>
